import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewPromiotionPaymentLayer from "../../components/PromotionPayment/ViewPromiotionPayment";
const ViewPromotionPaymentPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="Promotion Payment" link2="/transaction-promotion" title="View Promotion Payment" />

        {/* AddUserLayer */}
        <ViewPromiotionPaymentLayer />


      </MasterLayout>
    </>
  );
};

export default ViewPromotionPaymentPage;
